import React, { createContext, useContext } from "react";

const DemoContext = createContext(false);

export const DemoProvider: React.FC<{
  isDemo: boolean;
  children: React.ReactNode;
}> = ({ isDemo, children }) => (
  <DemoContext.Provider value={isDemo}>{children}</DemoContext.Provider>
);

export const useDemo = (): boolean => useContext(DemoContext);
